import { Injectable, inject } from '@angular/core';

import { JwtHelperService } from '@auth0/angular-jwt';
import _ from 'lodash';

import { PermissionsDTO } from '@api';

import { DecodedToken, User } from './models';

@Injectable()
export class TokenService {
  private readonly jwtHelper = inject(JwtHelperService);

  tokenName = '__token__';

  get token() {
    return localStorage.getItem(this.tokenName);
  }

  set token(token) {
    if (token) {
      localStorage.setItem(this.tokenName, token);
    } else {
      localStorage.removeItem(this.tokenName);
    }
  }

  get user(): User | undefined {
    return this.decodedToken()?.user;
  }

  get permissions(): PermissionsDTO[] | undefined {
    return this.decodedToken()?.permissions;
  }

  // Check if any of the passed permissions is met
  hasPermission(permission: PermissionsDTO | PermissionsDTO[]): boolean {
    if (Array.isArray(permission)) {
      return _.some(permission, (p) => this.permissions?.indexOf(p) !== undefined && this.permissions.indexOf(p) > -1);
    }
    return this.permissions?.indexOf(permission) !== undefined && this.permissions.indexOf(permission) > -1;
  }

  isTokenExpired() {
    return !this.token || this.jwtHelper.isTokenExpired(this.token);
  }

  private decodedToken(): DecodedToken | null {
    if (!this.token) {
      return null;
    }

    return this.jwtHelper.decodeToken(this.token);
  }
}
